var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loginModal.active)?_c('modal-login',{attrs:{"handle-close-click":_vm.hideLoginModal}}):_vm._e(),_vm._v(" "),(_vm.errorModal.active)?_c('modal-error',{attrs:{"handle-close-click":_vm.hideErrorModal}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }